import cx from 'classnames'
import IconSVG from 'svg-inline-react'
import arrowIconSrc from '!svg-inline!images/svg/playbooks-card-arrow-right.svg'
import closeIconSrc from '!svg-inline?removeTags=true!images/svg/onboarding/close.svg'
import pencilIconSrc from '!svg-inline!images/svg/pencil.svg'

import styles from './style.styl'

const Action = ({ label, children, onEditClick, onDeleteClick }) =>
  <div className={cx(styles.Action, 'flex')}>
    <div className="action-icon">
      <IconSVG src={arrowIconSrc} />
    </div>
    <div className="action-content">
      <div>
        {label && <div className="action-label">{label}</div>}
        <div className={cx({ 'no-edit': !onEditClick })}>{children}</div>
      </div>
      <div className="action-icons">
        {!!onEditClick &&
          <IconSVG
            className="action-tool-icon action-edit-icon"
            src={pencilIconSrc}
            onClick={onEditClick}
          />
        }
        {!!onDeleteClick &&
          <IconSVG
            className="action-tool-icon action-delete-icon"
            src={closeIconSrc}
            onClick={onDeleteClick}
          />
        }
      </div>
    </div>
  </div>

export default Action



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Action/index.js